import classList from '@/controllers/class/class-list';

export default {
  extends: classList,

  methods: {
    showImport() {
      this.$router.push({ name: 'classImport' });
    },
  }
}
